/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './ExternalInvestmentLearnMoreModal.scss';

import { string, bool } from 'prop-types';
import React from 'react';

import BaseModal from '../Modal/BaseModal';

import ExternalInvestmentLearnMore from './ExternalInvestmentLearnMore';

const ExternalInvestmentLearnMoreModal = ({
  className = '',
  hideLinkContent,
  content
}) => (
  <BaseModal
    containerClassName={
      'modal-info-container modal-external-investment-learn-more-container ' +
      className
    }
    icon={null}
    linkContentClass={'external-link-button'}
    linkContent={hideLinkContent ? null : 'Learn More'}
    title={'Learn More'}
    renderModalContent={<ExternalInvestmentLearnMore content={content} />}
  />
);

ExternalInvestmentLearnMoreModal.propTypes = {
  className: string,
  content: string,
  hideLinkContent: bool
};

ExternalInvestmentLearnMoreModal.defaultProps = {
  hideLinkContent: false
};

export default ExternalInvestmentLearnMoreModal;
